import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetTask } from 'selectors/tasks';

import { assignTask, unassignTask } from 'actions/tasks';

import { isTempId } from 'utils/helpers';
import { isSubtaskTask } from 'utils/task';
import { useCanUser } from 'shared-hooks/permission';

import UsersList from 'components/users-list';

const EMPTY_ARRAY = [];

const TaskAssignees = ({ id, projectId, createdBy, completed, archived, assignees, isSubtask, hideIfEmpty, avatarSize = 'small', maxUsersCount = 3, addUserText, addBtnClassName, withTooltip = true, onAssign, onUnassign, t }) => {
    const canAssignToTask = useCanUser(isSubtask ? 'assignToSubtask' : 'assignToTask', createdBy);
    const canUnassignFromTask = useCanUser(isSubtask ? 'unassignFromSubtask' : 'unassignFromTask', createdBy);

    const handleAssigneeRemove = useCallback(userId => {
        if (onUnassign) {
            onUnassign(userId);
            return;
        }

        unassignTask(id, [userId]);
    }, [id, onUnassign]);

    const handleAssigneeAdd = useCallback(user => {
        if (onAssign) {
            onAssign(user.id || user);
            return;
        }

        assignTask(id, [user.id || user]);
    }, [id, onAssign]);

    const isTemp = useMemo(() => isTempId(id), [id]);


    if (isTemp) {
        return null;
    }

    if (hideIfEmpty && !assignees?.length && !canAssignToTask) {
        return null;
    }

    return (
        <UsersList
            popoutTitle={ isSubtask ? t('actions.Assign Subtask to') : t('actions.Assign Task to') }
            projectId={projectId}
            editable={!completed && !archived && canAssignToTask}
            size={avatarSize}
            border={true}
            users={assignees}
            maxUsersCount={maxUsersCount}
            popoutSize="xxsmall"
            subtitles={canUnassignFromTask ? t('user:Un-assign user') : null}
            emailMatchText={ t('invite.match') }
            noMatchText={ t('invite.noMatch') }
            closeOnEveryClick={true}
            excludedUsers={assignees}
            btnClassName={addBtnClassName}
            addUserText={addUserText}
            addUserTooltip={ withTooltip ? t('user:Add assignee') : null }
            onSubtitleClick={handleAssigneeRemove}
            onUserSelect={handleAssigneeAdd}
        />
    )
}

const makeMapStateToProps = () => {
    const getTask = makeGetTask();
    const getParentTask = makeGetTask();

    return ({ tasks }, ownProps) => {
        const task = getTask(tasks.items, ownProps.id);
        const parentTaskId = task?.task;
        const parentTask = getParentTask(tasks.items, parentTaskId);
        const projectId = task?.project || parentTask?.project;

        return {
            projectId,
            createdBy: task?.created_by,
            completed: task?.completed,
            archived: task?.archived,
            assignees: task?.assignees || EMPTY_ARRAY,
            isSubtask: isSubtaskTask(task)
        }
    }
}

export default connect(makeMapStateToProps)(withTranslation(['task', 'user'])(TaskAssignees));
